<template>
    <v-app>
        <div class="text-center">
            <v-dialog
                v-model="$parent.closeConfirmModal"
                width="500"
            >
                <v-card>
                    <v-card-title class="text-h6 grey lighten-2">
                        {{ text }}
                    </v-card-title>

                    <v-card-text class="pt-3 pb-0">
                        Are you sure you want to do this?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pt-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="$parent.closeConfirmModal"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            color="success"
                            text
                            @click="confirmedClick"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-app>
</template>

<script>
export default {
    name: "ConfirmationModal",
    props: {
        text: String,
        action: String,
    },
    methods: {
        confirmedClick() {
            this.$emit('confirmedModal', this.action)
        }
    }
}
</script>

<style scoped>

</style>